export default "/images/vendor/flag-icon-css/flags/4x3/cg.svg?440e321a39cf550b0bec17d9fd107038";